// @flow
import React from 'react';
import prop from 'ramda/es/prop';
import path from 'ramda/es/path';
import { useTranslation } from 'react-i18next';

import Indicator from 'app/components/Subs/Indicator';
import { TARIFF_MONTHLY, TARIFF_EXTERNAL_SYSTEM } from 'app/common/constants/tariffs';
import AvailableInformers from 'app/components/Tariff/AvailableInformers';

import type { TariffType, Sub } from '../Tariff';
import MonthDailyPeriods from './MonthDailyPeriods';
import styles from './InformsStandart.scss';


/**
 * InformsStandart
 */
type Props = {
  sub?: Sub,
  tariff: TariffType,
  subId?: string,
  footnotes: Object,
  studentId: number,
}

const InformsStandart = ({
  sub,
  tariff,
  subId,
  footnotes,
  studentId,
}: Props) => {
  const { t } = useTranslation('tariff');

  return (
    <div className={styles.root}>
      <div className={styles.informs}>
        <div className={styles.title}>{`${t('informs_title')}:`}</div>
        <AvailableInformers
          tariff={tariff}
          footnotes={footnotes}
        />
      </div>

      {sub
        && tariff.kind !== TARIFF_MONTHLY
        // для TARIFF_MONTHLY индикатор внутри MonthDailyPeriods
        // чтоб была возможность его скрыть
        && <div>
          <Indicator subId={subId} showCircle />
        </div>}

      {tariff.kind === TARIFF_MONTHLY
        && <MonthDailyPeriods
          subId={subId}
          periods={path(['month_daily_params', 'periods'], tariff)}
          isPeriodSubscribed={!!prop('prepaid_stop_at', sub)}
          footnotes={footnotes}
          locked={prop('is_paused', sub)}
          studentId={studentId}
          tariffId={!tariff.inside ? tariff.id : undefined}
          tariffBundleId={tariff.inside ? tariff.id : undefined}
        />}

      {tariff.kind === TARIFF_EXTERNAL_SYSTEM
        && <div
          className={styles.externalInfo}
          dangerouslySetInnerHTML={{ __html: tariff.activation_info }}
        />}
    </div>
  );
};

export default InformsStandart;
